import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { Plus as PlusIcon } from 'react-feather'
import { useForm } from 'react-hook-form'

import {
  BaseDialog,
  CompanyTypeAndSeachInput,
  LoadingFeedback,
} from 'components'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'
import * as service from 'service'
import helpers from 'helpers'

const AddCompanyDialog = ({ integrationPartner, refresh }) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const { control, handleSubmit, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      companyId: null,
    },
  })

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.integrationPartners.linkCompany({
        integrationPartnerId: integrationPartner?.id,
        companyId: data.companyId?.id,
      })

      setOpen(false)

      snackbar.open({
        message: 'Empresa vinculada com sucesso',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          'Ocorreu um erro ao vincular a empresa',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />

      <Button
        variant="outlined"
        color="primary"
        startIcon={<PlusIcon />}
        onClick={() => setOpen(true)}
      >
        Criar
      </Button>

      <BaseDialog
        open={open}
        setOpen={setOpen}
        title="Vincular Empresa"
        closeButtonText="Cancelar"
        actionButtonText="Vincular"
        formRef="vinculate-company-form"
      >
        <form onSubmit={handleSubmit(onSubmit)} id="vinculate-company-form">
          <CompanyTypeAndSeachInput
            control={control}
            errors={errors}
            label="Empresa"
          />
        </form>
      </BaseDialog>
    </>
  )
}

export default AddCompanyDialog
